import React from 'react';
import ReactQuill, { ReactQuillProps } from 'react-quill';
import clsx from 'clsx';
import 'react-quill/dist/quill.snow.css';
import './index.scss';

interface QuillRichTextEditor {
  value?: string;
  onChange?: (value: string) => void;
  hideToolbar?: boolean;
  readOnly?: boolean;
  autoHeight?: boolean;
}

function QuillRichTextEditor({ value, onChange, hideToolbar, readOnly, autoHeight }: QuillRichTextEditor) {
  /** https://quilljs.com/docs/modules/toolbar/ */
  const modules: ReactQuillProps['modules'] = {
    toolbar: [
      [{ header: [1, 2, 3, false] }], // [{ size: ['small', false, 'large', 'huge'] }],
      ['bold', 'italic', 'underline', 'strike'], // 'blockquote'
      [{ list: 'ordered' }, { list: 'bullet' }], // { indent: '-1' }, { indent: '+1' }
      // [{ color: ['blue', 'grey'] }, { background: [] }], // Color and background color selectors
      // [{ font: [] }], // Chose Font-family
      [{ align: [] }], // Text-align selector.
      ['link'], // 'image'
      ['clean'],
    ],
    clipboard: { matchVisual: false }, // https://github.com/zenoamaro/react-quill/issues/409
    // If remove 'false', then before 'ul' & 'ol' will appear additional <p><br/></p>
  };

  const handleChange = (val: string) => {
    /** If value is empty then quill returns it as '<p><br></p>' */
    if (val === '<p><br></p>') {
      return onChange?.('');
    }

    return onChange?.(val);
  };

  return (
    <ReactQuill
      value={value}
      onChange={handleChange}
      className={clsx('quill-customized', hideToolbar ? 'hideToolBar' : '', autoHeight ? 'autoHeight' : '')}
      placeholder="Input text..."
      modules={modules}
      readOnly={readOnly}
    />
  );
}

QuillRichTextEditor.defaultProps = {
  value: '',
  onChange: () => undefined,
  hideToolbar: false,
  readOnly: false,
  autoHeight: false,
};

export default QuillRichTextEditor;
